import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingOverlay from '../Partials/LoadingOverlay';

interface PrivateRouteProps {
  children: React.ReactElement;
  requiresElite?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requiresElite = false }) => {
  const { isAuthenticated, isDataLoading, isSubscriptionLoading, isLoading, user, subscription } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isDataLoading && !isSubscriptionLoading) {
      if (!isAuthenticated) {
        navigate('/login');
      } else if (requiresElite && (user && (!subscription || subscription.plan !== 'ultimate'))) {
        navigate('/pricing#study-spaces');
      }
    }
  }, [isAuthenticated, isLoading, navigate, requiresElite, user, subscription, isSubscriptionLoading, isDataLoading]);

  if (isLoading || isDataLoading || isSubscriptionLoading) {
    return <LoadingOverlay message="" isLoading={true} />;
  }

  if (requiresElite && (!subscription || subscription.plan !== 'ultimate')) {
    return null;
  }

  return isAuthenticated ? children : null;
};

export default PrivateRoute;